import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { NotFound } from 'views/NotFound';

// Captured once when this module is first evaluated — this is the URL the
// browser was at when the SPA bootstrapped.
const entryPathname =
  typeof window !== 'undefined' ? window.location.pathname : '';

/**
 * Catches any client-side navigation to a `/g/*` URL and converts it into a
 * full-page navigation. Routes under `/g/*` are owned by another app
 * (point-o), so when react-router would otherwise mount this element we let
 * the browser request the URL from the server instead.
 *
 * Safety net: if the SPA bootstrapped at a `/g/*` URL (e.g. the server
 * incorrectly fell back to gms-react instead of routing to point-o), a
 * `window.location.replace` would just reload the same URL and loop
 * forever. In that case we render a NotFound view instead.
 */
export const ExternalGRouteRedirect = (): JSX.Element | null => {
  const location = useLocation();
  const isEntryPoint = location.pathname === entryPathname;

  useEffect(() => {
    if (isEntryPoint) return;
    window.location.replace(
      `${location.pathname}${location.search}${location.hash}`
    );
  }, [isEntryPoint, location.pathname, location.search, location.hash]);

  return isEntryPoint ? <NotFound /> : null;
};
